export default "__VITE_ASSET__hL7Th8ih__"